module.exports = __webpack_public_path__ + "img/img49.66592523.svg";